import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import config from '../../config/apiConfig';
import { toast, ToastContainer } from 'react-toastify';
import TerminalSelector from '../Pedidos/TerminalSelector';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../../imgs/logo_komity.png';

const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1
};

export default function Login({ setLogin }) {
    const [pin, setPin] = useState('');
    const [loading, setLoading] = useState(false);
    const [bloqueado, setBloqueado] = useState(null);
    const [pendingLogin, setPendingLogin] = useState(null); // datos login esperando selección de caja // null = cargando, false = ok, objeto = bloqueado
    const [planNegocio, setPlanNegocio] = useState(null);
    const [tieneStaff, setTieneStaff] = useState(true); // por defecto true: no mostrar el bypass hasta confirmar
    // 🚩 Plan Menú QR SIN staff configurado (dueño solo). En vez del teclado
    // numérico (pensado para varios meseros/cajeros compartiendo un mismo
    // terminal), se pide email+clave de administrador directo. Si el negocio
    // ya tiene staff, sigue usando el PIN normal aunque el plan sea Menú QR.
    const [emailAdmin, setEmailAdmin] = useState('');
    const [passwordAdmin, setPasswordAdmin] = useState('');
    const miHistorial = useHistory();

    // 🚩 VERIFICAR BLOQUEO AL CARGAR LA PANTALLA
    useEffect(() => {
        const negocioId = localStorage.getItem("negocioId");
        if (!negocioId) {
            setBloqueado(false);
            return;
        }

        const verificarBloqueo = async () => {
            try {
                const res = await axios.post(config.api_url + '/api/negocios/verificar-bloqueo', {
                    negocio_id: negocioId
                });
                if (res.data && res.data.status === "success") {
                    setPlanNegocio(res.data.data.plan || null);
                    setTieneStaff(Boolean(res.data.data.tieneStaff));
                    // 🚩 Persistimos para que App.js sepa, al cerrar sesión, si este
                    // negocio usa PIN (/login) o admin-login (/adminlogin) — no debe
                    // decidirse por el rol del último usuario logueado.
                    localStorage.setItem('tieneStaff', String(Boolean(res.data.data.tieneStaff)));
                    if (res.data.data.bloqueado) {
                        setBloqueado({
                            tipo: 'BLOQUEADA',
                            mensaje: res.data.data.mensaje || '⚠️ Este negocio ha sido bloqueado.'
                        });
                    } else if (res.data.data.estado === 'PENDIENTE') {
                        // Período de gracia: mostrar advertencia pero permitir acceso
                        setBloqueado({
                            tipo: 'PENDIENTE',
                            mensaje: res.data.data.mensaje || '⚠️ Tu servicio está próximo a vencer.',
                            dias_gracia: res.data.data.dias_gracia_restantes || 0
                        });
                    } else {
                        setBloqueado(false);
                    }
                } else {
                    setBloqueado(false);
                }
            } catch (err) {
                console.error("Error verificando bloqueo:", err);
                setBloqueado(false);
            }
        };

        verificarBloqueo();
    }, []);

    // --- COMPLETAR LOGIN (después de elegir caja) ---
    const completarLogin = (loginData) => {
        setLogin({ token: loginData.token, usuario: loginData.usuario, config: null });
        toast.success("¡Bienvenido, " + loginData.usuario.nombre + "!");
        const rol = loginData.rol;
        if (rol === 'cocina' || rol === 'kds') {
            miHistorial.push("/kds/");
        } else if (['admin', 'administrador', 'operador'].includes(rol)) {
            miHistorial.push("/home/");
        } else if (rol === 'garzon' || rol === 'garzón') {
            miHistorial.push("/mesas/");
        } else {
            miHistorial.push("/ventas/tpv");
        }
    };

    const handleCajaSeleccionada = (nombre) => {
        if (nombre) { localStorage.setItem('terminalNombre', nombre); }
        else { localStorage.removeItem('terminalNombre'); }
        completarLogin(pendingLogin);
    };

    // --- 1. LÓGICA DE LOGIN ---
    const handleLoginPIN = async (pinActual) => {
        const pinAEnviar = pinActual || pin;
        if (pinAEnviar.length < 4) return;

        const negocioIdVinculado = localStorage.getItem("negocioId");

        // 🚩 VALIDAR QUE EL DISPOSITIVO ESTÉ VINCULADO
        if (!negocioIdVinculado) {
            setPin('');
            setLoading(false);
            toast.error("⚠️ Este dispositivo no está vinculado a ningún negocio. Ve a Vincular Dispositivo.");
            return;
        }

        setLoading(true);
        const urlLogin = config.api_url + '/api/staff/login';

        try {
            const res = await axios.post(urlLogin, { pin: pinAEnviar, negocio_id: negocioIdVinculado });

            if (res.data && res.data.status === "success") {
                // Guardar sesión en localStorage
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("negocioId", res.data.negocioId);
                localStorage.setItem("usuario", JSON.stringify({
                    nombre: res.data.nombre,
                    rol: res.data.rol,
                    uuid: res.data.staff_uuid
                }));

                // Consultar cuántas cajas tiene el negocio
                let cajas = [];
                try {
                    const resCajas = await axios.get(
                        config.api_url + '/api/v1/mesas/terminales',
                        { headers: { token: res.data.token } }
                    );
                    cajas = Array.isArray(resCajas.data) ? resCajas.data : [];
                } catch (_) { cajas = []; }

                const rolUsuario = (res.data.rol || '').toLowerCase();
                const loginData = {
                    token: res.data.token,
                    usuario: { nombre: res.data.nombre, rol: res.data.rol },
                    rol: rolUsuario
                };

                if (cajas.length >= 2) {
                    // Mostrar selector de caja antes de entrar
                    setPendingLogin(loginData);
                    setLoading(false);
                    return;
                }

                // 0 o 1 caja: auto-seleccionar y entrar directo
                if (cajas.length === 1) {
                    localStorage.setItem('terminalNombre', cajas[0].nombre);
                } else {
                    localStorage.removeItem('terminalNombre');
                }

                completarLogin(loginData);
            } else {
                // --- PIN INCORRECTO ---
                setPin(''); // Limpiar los puntitos
                toast.error("❌ PIN incorrecto. Inténtalo de nuevo.");
            }
        } catch (err) {
            setPin('');
            // 🚩 Si el error viene del backend con mensaje específico (bloqueo, etc.)
            if (err.response && err.response.data && err.response.data.message) {
                toast.error(err.response.data.message);
            } else {
                toast.error("⚠️ Error de conexión con el servidor");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleIrAAdminLogin = () => {
        window.location.replace("/adminlogin");
    };

    // --- LOGIN DIRECTO CON EMAIL+CLAVE (solo plan Menú QR, sin PIN) ---
    const handleLoginAdminDirecto = async (e) => {
        e.preventDefault();
        if (!emailAdmin || !passwordAdmin) return toast.warning("Completa email y contraseña");

        setLoading(true);
        try {
            const res = await axios.post(config.api_url + '/api/auth/admin-login', {
                email: emailAdmin.trim(),
                password: passwordAdmin.trim()
            });

            if (res.data && res.data.status === "success") {
                // 🚩 vtgx_usuarios_admin.rol usa roles de NEGOCIO (DUEÑO/GERENTE/
                // SOPORTE), no los roles de SESIÓN que usa el resto de la app
                // (ADMIN/OPERADOR/GARZON/COCINA). Este login solo lo usa el
                // dueño de la cuenta, así que la sesión siempre es 'ADMIN'.
                // Este flujo solo se muestra cuando !tieneStaff, así que lo dejamos
                // explícito para el logout de App.js.
                localStorage.setItem('tieneStaff', 'false');
                setLogin({
                    token: res.data.token,
                    usuario: { nombre: res.data.nombre, rol: 'ADMIN' },
                    config: null
                });
                toast.success("¡Bienvenido, " + res.data.nombre + "!");
                // Plan Menú QR: en vez del dashboard genérico de ventas, entra
                // al checklist de configuración del catálogo (/home/).
                miHistorial.push("/home/");
            } else {
                toast.error("❌ " + (res.data.message || "Credenciales incorrectas"));
            }
        } catch (err) {
            toast.error("⚠️ Error de conexión con el servidor");
        } finally {
            setLoading(false);
        }
    };

    const handleDesvincular = () => {
        if (window.confirm("¿Deseas desvincular esta terminal? Deberás usar la clave de administrador nuevamente.")) {
            localStorage.clear(); // Borra todo el caché
            sessionStorage.clear(); // Por si las moscas
            window.location.replace("/"); // 🚩 replace() hace un reseteo duro del navegador
        }
    };

    // --- 4. MANEJO DE TECLADO ---
    const handleNumberClick = useCallback((num) => {
        if (pin.length < 4) setPin(prev => prev + num);
    }, [pin]);

    const handleDelete = useCallback(() => {
        setPin(prev => prev.slice(0, -1));
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (/^[0-9]$/.test(event.key)) handleNumberClick(event.key);
            if (event.key === 'Backspace') handleDelete();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [handleNumberClick, handleDelete]);

    // Auto-login al llegar a 4 dígitos
    useEffect(() => {
        if (pin.length === 4 && !loading) {
            handleLoginPIN(pin);
        }
    }, [pin]);


  const estilosLogin = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

    /* =========================================
       FONDO CON GRADIENTE DINÁMICO
       ========================================= */
    .login-wrapper {
        font-family: 'Inter', sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        width: 100vw;
        padding: 24px 16px;
        box-sizing: border-box;
        background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
        position: relative;
        overflow-x: hidden;
        overflow-y: auto;
    }

    /* Círculos decorativos de fondo */
    .login-wrapper::before {
        content: '';
        position: absolute;
        width: 600px;
        height: 600px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(242,107,33,0.15) 0%, transparent 70%);
        top: -200px;
        right: -200px;
        animation: float-circle 8s ease-in-out infinite;
    }

    .login-wrapper::after {
        content: '';
        position: absolute;
        width: 400px;
        height: 400px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(242,107,33,0.1) 0%, transparent 70%);
        bottom: -100px;
        left: -100px;
        animation: float-circle 10s ease-in-out infinite reverse;
    }

    @keyframes float-circle {
        0%, 100% { transform: translate(0, 0) scale(1); }
        50% { transform: translate(30px, -30px) scale(1.1); }
    }

    /* =========================================
       CARD PRINCIPAL (Glassmorphism)
       ========================================= */
    .login-container {
        width: 100%;
        max-width: 400px;
        padding: 45px 30px 35px;
        text-align: center;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(20px);
        border-radius: 28px;
        box-shadow: 
            0 25px 60px rgba(0, 0, 0, 0.3),
            0 0 0 1px rgba(255, 255, 255, 0.1);
        position: relative;
        z-index: 2;
        animation: slide-up 0.5s ease-out;
    }

    @keyframes slide-up {
        from { opacity: 0; transform: translateY(30px); }
        to { opacity: 1; transform: translateY(0); }
    }

    .welcome-title {
        font-weight: 700;
        font-size: 1.5rem;
        color: #1a1c1d;
        margin-bottom: 4px;
    }

    .subtitle {
        color: #94a3b8;
        font-size: 0.85rem;
        font-weight: 500;
        margin-bottom: 35px;
    }

    /* =========================================
       PUNTITOS DEL PIN (más grandes y vistosos)
       ========================================= */
    .pin-display {
        display: flex;
        justify-content: center;
        gap: 18px;
        margin-bottom: 40px;
    }

    .dot {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #e2e8f0;
        transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.5);
        border: 2px solid transparent;
    }

    .dot.filled {
        background-color: #f26b21;
        border-color: #f26b21;
        transform: scale(1.2);
        box-shadow: 0 0 20px rgba(242, 107, 33, 0.5);
    }

    /* =========================================
       TECLADO MODERNO
       ========================================= */
    .keypad-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        margin-bottom: 25px;
    }

    .key-btn {
        height: 64px;
        border-radius: 16px;
        border: none;
        background: #f8fafc;
        font-size: 1.5rem;
        font-weight: 700;
        color: #1e293b;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.15s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
        position: relative;
        overflow: hidden;
    }

    .key-btn::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(135deg, rgba(242,107,33,0.1), transparent);
        opacity: 0;
        transition: opacity 0.2s;
    }

    .key-btn:hover {
        background: #fff;
        box-shadow: 0 4px 12px rgba(242, 107, 33, 0.15);
        transform: translateY(-2px);
        color: #f26b21;
    }

    .key-btn:hover::after {
        opacity: 1;
    }

    .key-btn:active {
        transform: scale(0.92);
        background: #f26b21;
        color: #fff;
        box-shadow: 0 2px 8px rgba(242, 107, 33, 0.3);
    }

    .btn-action-key {
        background: #f1f5f9;
        color: #64748b;
    }

    .btn-action-key:hover {
        background: #e2e8f0;
        color: #475569;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }

    .btn-enter {
        background: linear-gradient(135deg, #f26b21, #f59e42);
        color: #ffffff;
        box-shadow: 0 4px 15px rgba(242, 107, 33, 0.35);
    }

    .btn-enter:hover {
        background: linear-gradient(135deg, #e05d15, #f48c30);
        color: #fff;
        box-shadow: 0 6px 20px rgba(242, 107, 33, 0.45);
        transform: translateY(-2px);
    }

    .btn-enter:active {
        transform: scale(0.92);
    }

    .btn-enter:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

    /* =========================================
       FOOTER
       ========================================= */
    .login-footer {
        margin-top: 20px;
    }

    .btn-desvincular {
        background: none;
        border: none;
        color: #94a3b8;
        font-size: 0.75rem;
        font-weight: 600;
        letter-spacing: 0.5px;
        cursor: pointer;
        transition: color 0.2s;
        padding: 8px 16px;
        border-radius: 8px;
    }

    .btn-desvincular:hover {
        color: #ef4444;
        background: rgba(239, 68, 68, 0.05);
    }

    .login-version {
        color: #cbd5e1;
        font-size: 0.6rem;
        font-weight: 700;
        letter-spacing: 2px;
        margin-top: 12px;
        text-transform: uppercase;
    }

    /* =========================================
       PANTALLAS DE POCA ALTURA (compactar)
       ========================================= */
    @media (max-height: 700px) {
        .login-container {
            padding: 24px 24px 20px;
        }
        .welcome-title {
            margin-bottom: 2px;
        }
        .subtitle {
            margin-bottom: 18px;
        }
        .pin-display {
            margin-bottom: 20px;
        }
        .keypad-grid {
            gap: 8px;
            margin-bottom: 14px;
        }
        .key-btn {
            height: 48px;
        }
        .login-footer {
            margin-top: 8px;
        }
        .login-version {
            margin-top: 6px;
        }
    }
`;

   // 🚩 Si está cargando la verificación de bloqueo, mostrar spinner
   if (bloqueado === null) {
       return (
           <div className="login-wrapper">
               <style dangerouslySetInnerHTML={{ __html: estilosLogin }} />
               <div className="login-container" style={{ padding: '60px 30px' }}>
                   <div style={{ margin: '40px 0' }}>
                       <div style={{
                           width: '40px', height: '40px',
                           border: '4px solid #e2e8f0', borderTopColor: '#f26b21',
                           borderRadius: '50%', animation: 'spin 0.6s linear infinite',
                           margin: '0 auto 16px'
                       }}/>
                       <p style={{ color: '#94a3b8', fontSize: '14px' }}>Verificando estado del servicio...</p>
                   </div>
                   <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
               </div>
           </div>
       );
   }

   // 🚩 BLOQUEADA: ya no bloqueamos en login. El overlay post-login lo maneja App.js (PantallaBloqueo).

   // 🚩 NEGOCIO NO VINCULADO: Pantalla con instrucciones claras
   if (bloqueado === false && !localStorage.getItem("negocioId")) {
       return (
           <div className="login-wrapper">
               <style dangerouslySetInnerHTML={{ __html: estilosLogin }} />
               <div className="login-container" style={{ textAlign: 'left' }}>
                   <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                       <div style={{ fontSize: '2.5rem', marginBottom: '8px' }}>🔗</div>
                       <h1 className="welcome-title">Terminal no vinculada</h1>
                       <p className="subtitle" style={{ marginBottom: 0 }}>Este equipo aún no está conectado a ningún negocio en Komity.</p>
                   </div>
                   <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '20px', marginBottom: '20px' }}>
                       <p style={{ fontWeight: 700, fontSize: '13px', color: '#1e293b', marginBottom: '12px' }}>¿Cómo vincular este equipo?</p>
                       <ol style={{ margin: 0, paddingLeft: '20px', fontSize: '13px', color: '#64748b', lineHeight: '1.8' }}>
                           <li>Inicia sesión con el <strong style={{ color: '#1e293b' }}>correo y contraseña de administrador</strong> del negocio.</li>
                           <li>Eso vincula este equipo automáticamente.</li>
                           <li>Después los empleados pueden entrar con su PIN.</li>
                       </ol>
                   </div>
                   <button onClick={handleIrAAdminLogin} style={{
                       width: '100%', padding: '15px 24px',
                       background: 'linear-gradient(135deg, #7A27F5, #FC1958)',
                       color: '#fff', border: 'none', borderRadius: '14px',
                       fontSize: '15px', fontWeight: '700', cursor: 'pointer',
                       boxShadow: '0 4px 15px rgba(122,39,245,0.35)'
                   }}>
                       <i className="bi bi-link-45deg mr-1"></i> Vincular con cuenta de administrador
                   </button>
                   <div style={{ textAlign: 'center', marginTop: '16px' }}>
                       <a href="https://wa.me/56920039433" target="_blank" rel="noreferrer" style={{ fontSize: '12px', color: '#94a3b8', textDecoration: 'none' }}>
                           ¿No tienes cuenta? Contáctanos por WhatsApp →
                       </a>
                   </div>
                   <div className="login-footer" style={{ textAlign: 'center' }}>
                       <div className="login-version">Komity POS v2.0</div>
                   </div>
               </div>
               <ToastContainer position="top-right" autoClose={3000} />
           </div>
       );
   }

    // Mostrar selector de caja si el login fue exitoso y hay 2+ cajas
    if (pendingLogin) {
        return <TerminalSelector onSeleccionar={handleCajaSeleccionada} />;
    }

    return (
     <div className="login-wrapper">
         <style dangerouslySetInnerHTML={{ __html: estilosLogin }} />

         <div className="login-container">
            {/* Banner BLOQUEADA — aviso antes de ingresar; el bloqueo real es post-login */}
            {bloqueado && bloqueado.tipo === 'BLOQUEADA' && (
                <div style={{
                    background: '#fef2f2', border: '1px solid #fecaca',
                    borderRadius: '12px', padding: '12px 16px',
                    marginBottom: '20px', textAlign: 'center'
                }}>
                    <p style={{ color: '#dc2626', fontSize: '12px', fontWeight: 700, margin: '0 0 4px' }}>
                        🔒 Servicio bloqueado por morosidad
                    </p>
                    <p style={{ color: '#991b1b', fontSize: '11px', margin: 0 }}>
                        Contacta a soporte para regularizar: soporte@komity.cl
                    </p>
                </div>
            )}

            {/* Banner PENDIENTE — período de gracia */}
            {bloqueado && bloqueado.tipo === 'PENDIENTE' && (
                <div style={{
                    background: '#fffbeb', border: '1px solid #fde68a',
                    borderRadius: '12px', padding: '12px 16px',
                    marginBottom: '20px', textAlign: 'center'
                }}>
                    <p style={{ color: '#92400e', fontSize: '12px', fontWeight: 600, margin: '0 0 4px' }}>
                        ⚠️ {bloqueado.mensaje}
                    </p>
                    {bloqueado.dias_gracia > 0 && (
                        <span style={{
                            display: 'inline-block', background: '#f59e0b', color: '#fff',
                            padding: '2px 12px', borderRadius: '20px',
                            fontSize: '11px', fontWeight: 700
                        }}>
                            ⏳ {bloqueado.dias_gracia} día(s) de gracia restantes
                        </span>
                    )}
                </div>
            )}
            {/* LOGO KOMITY */}
            <img src={logo} alt="Komity" style={{ width: '160px', marginBottom: '16px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
            <h1 className="welcome-title" style={{ marginTop: '10px' }}>Bienvenido</h1>

            {planNegocio === 'MENU_QR' && !tieneStaff ? (
                <>
                    <p className="subtitle">Ingresa con tu email y contraseña</p>
                    <form onSubmit={handleLoginAdminDirecto} style={{ textAlign: 'left', marginBottom: '10px' }}>
                        <input
                            type="email"
                            className="form-control komity-input"
                            placeholder="Email"
                            value={emailAdmin}
                            onChange={(e) => setEmailAdmin(e.target.value)}
                            style={{ marginBottom: '12px', width: '100%', padding: '12px', borderRadius: '10px', border: '1.5px solid #e2e8f0' }}
                        />
                        <input
                            type="password"
                            className="form-control komity-input"
                            placeholder="Contraseña"
                            value={passwordAdmin}
                            onChange={(e) => setPasswordAdmin(e.target.value)}
                            style={{ marginBottom: '20px', width: '100%', padding: '12px', borderRadius: '10px', border: '1.5px solid #e2e8f0' }}
                        />
                        <button type="submit" className="btn-enter" disabled={loading} style={{ width: '100%', padding: '14px', borderRadius: '14px', border: 'none', fontSize: '1rem', fontWeight: 700 }}>
                            {loading ? <span className="spinner-border spinner-border-sm"></span> : 'Ingresar'}
                        </button>
                    </form>
                </>
            ) : (
                <>
                    <p className="subtitle">Ingresa tu PIN para acceder al terminal</p>

                    {/* VISOR DE PIN */}
                    <div className="pin-display">
                        {[0, 1, 2, 3].map(i => (
                            <div key={i} className={`dot ${pin.length > i ? 'filled' : ''}`}></div>
                        ))}
                    </div>

                    {/* TECLADO */}
                    <div className="keypad-grid">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
                            <button key={num} className="key-btn" aria-label={`Dígito ${num}`} onClick={() => handleNumberClick(num.toString())}>
                                {num}
                            </button>
                        ))}

                        <button className="key-btn btn-action-key" aria-label="Borrar último dígito" onClick={handleDelete}>
                            <i className="bi bi-backspace"></i>
                        </button>

                        <button className="key-btn" aria-label="Dígito 0" onClick={() => handleNumberClick("0")}>
                            0
                        </button>

                        <button className="key-btn btn-enter" aria-label="Ingresar PIN" onClick={() => handleLoginPIN()} disabled={pin.length < 4 || loading}>
                            {loading ? <span className="spinner-border spinner-border-sm"></span> : <i className="bi bi-arrow-right-short"></i>}
                        </button>
                    </div>
                </>
            )}

             {/* FOOTER */}
             <div className="login-footer">
                 <button className="btn-desvincular" onClick={handleDesvincular}>
                     ¿PROBLEMAS? DESVINCULAR DISPOSITIVO
                 </button>
                 <div className="login-version">
                     Komity POS v2.0
                 </div>
             </div>
         </div>

         {/* 🚩 TOAST CONTAINER AGREGADO PARA QUE LOS ERRORES SEAN VISIBLES */}
         <ToastContainer position="top-right" autoClose={3000} />
     </div>
 );

 }
